import { SINGLE_PAGE_VIEW_CONTEXT } from '../constants';

export const getPageExtractions = <T extends { page: number }>(page: number, extractionsSpecs: T[]): T[] => {
    return extractionsSpecs.filter((extraction) => extraction.page === page);
};

export const getContextPages = (pageNumber: number): number[] => {
    const contextPages: number[] = [];
    for (let page = pageNumber - SINGLE_PAGE_VIEW_CONTEXT; page <= pageNumber + SINGLE_PAGE_VIEW_CONTEXT; page++) {
        contextPages.push(page);
    }

    return contextPages;
};
